// extracted by mini-css-extract-plugin
export var boldText = "_66-4";
export var checkboxContainer = "_66-6";
export var closeIcon = "_66-i";
export var container = "_66-0";
export var drawer = "_66-8";
export var drawerContent = "_66-9";
export var extraSmallText = "_66-5";
export var fulfillmentGroupTable = "_66-e";
export var largeText = "_66-3";
export var loadingSpinnerContainer = "_66-j";
export var mediumText = "_66-2";
export var narrow = "_66-f";
export var notificationLink = "_66-l";
export var packageCheckIconContainer = "_66-7";
export var slideoutHeaderActions = "_66-g";
export var slideoutHeaderActionsShifted = "_66-h";
export var slideoutHeaderContainer = "_66-a";
export var slideoutModal = "_66-c";
export var stickyHeaderWrapper = "_66-b";
export var table = "_66-k";
export var tableContainer = "_66-d";
export var tertiaryText = "_66-1";